import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const CONFIG = {
  appName: 'mestore',
  appHostname: 'mestore.app',
  appVersion: packageJson.version,
  appDomain: 'https://mestore.app',
  appleStore: 'https://apps.apple.com/us/app/',
  googlePlay: 'https://play.google.com/store/apps/details?id=',
  serverUrl: process.env.NEXT_PUBLIC_SERVER_URL ?? '',
  assetsDir: process.env.NEXT_PUBLIC_ASSETS_DIR ?? '',
  isStaticExport: JSON.parse(`${process.env.BUILD_STATIC_EXPORT}`),
  appIllustration: {
    small: 'https://mestore.app/assets/illustrations/illustration-app-small.jpg',
    normal: 'https://mestore.app/assets/illustrations/illustration-app-normal.jpg',
    large: 'https://mestore.app/assets/illustrations/illustration-app-large.jpg',
  },
  appInvoice: {
    name: 'Mestore',
    phoneNumber: '+51917081351',
    email: 'info.mestore.app@gmail.com',
    fullAddress: 'Marchant Pereira 150 1002, Providencia, Chile',
  },
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */
  auth: {
    method: 'firebase',
    skip: false,
    redirectPath: '/',
  },
  /** MapBox */
  mapboxApiKey: process.env.NEXT_PUBLIC_MAPBOX_API_KEY ?? '',
  /** Google Maps */
  gmapsApiKey: process.env.NEXT_PUBLIC_GOOGLEMAPS_API ?? '',
  /** Mercadopago */
  mercadopago: {
    numberFormat: { code: 'es-CL', currency: 'CLP' },
    publicKey: process.env.NEXT_PUBLIC_MERCADOPAGO_PUBLIC_KEY ?? '',
    accessToken: process.env.NEXT_PUBLIC_MERCADOPAGO_ACCESS_TOKEN ?? '',
    test: {
      publicKey: process.env.NEXT_PUBLIC_MERCADOPAGO_PUBLIC_KEY_TEST ?? '',
      accessToken: process.env.NEXT_PUBLIC_MERCADOPAGO_ACCESS_TOKEN_TEST ?? '',
    },
    subscriptions: {
      publicKey: process.env.NEXT_PUBLIC_MERCADOPAGO_PUBLIC_KEY_SUBSCRIPTIONS ?? '',
      accessToken: process.env.NEXT_PUBLIC_MERCADOPAGO_ACCESS_TOKEN_SUBSCRIPTIONS ?? '',
      test: {
        payer_id: 2255256148,
        email: 'test_user_76304028@testuser.com',
        publicKey: process.env.NEXT_PUBLIC_MERCADOPAGO_PUBLIC_KEY_TEST_SUBSCRIPTIONS ?? '',
        accessToken: process.env.NEXT_PUBLIC_MERCADOPAGO_ACCESS_TOKEN_TEST_SUBSCRIPTIONS ?? '',
      },
    },
    peru: {
      numberFormat: { code: 'es-PE', currency: 'PEN' },
      publicKey: process.env.NEXT_PUBLIC_MERCADOPAGO_PUBLIC_KEY_PERU ?? '',
      accessToken: process.env.NEXT_PUBLIC_MERCADOPAGO_ACCESS_TOKEN_PERU ?? '',
      test: {
        publicKey: process.env.NEXT_PUBLIC_MERCADOPAGO_PUBLIC_KEY_TEST_PERU ?? '',
        accessToken: process.env.NEXT_PUBLIC_MERCADOPAGO_ACCESS_TOKEN_TEST_PERU ?? '',
      },
    },
  },
  /** Gmail */
  gmail: {
    apiKey: process.env.NEXT_PUBLIC_GMAIL_API ?? '',
  },
  /** Firebase */
  firebase: {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? '',
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL ?? '',
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? '',
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: process.env.NEXT_PUBLIC_FIREBASE_APPID ?? '',
  },
  /** Messaging */
  messaging: {
    fcm: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_FCM ?? '',
    vapidKey: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_VAPIDKEY ?? '',
  },
  /** reCAPTCHA */
  recaptcha: {
    siteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? '',
    secretKey: process.env.NEXT_PUBLIC_RECAPTCHA_SECRET_KEY ?? '',
  },
  /** Algolia */
  algolia: {
    appId: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? '',
    apiKey: process.env.NEXT_PUBLIC_ALGOLIA_API_KEY ?? '',
  },
  /** Amplify */
  amplify: {
    userPoolId: process.env.NEXT_PUBLIC_AWS_AMPLIFY_USER_POOL_ID ?? '',
    userPoolWebClientId: process.env.NEXT_PUBLIC_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID ?? '',
    region: process.env.NEXT_PUBLIC_AWS_AMPLIFY_REGION ?? '',
  },
  /** Auth0 */
  auth0: {
    clientId: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID ?? '',
    domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN ?? '',
    callbackUrl: process.env.NEXT_PUBLIC_AUTH0_CALLBACK_URL ?? '',
  },
  /** Supabase */
  supabase: {
    url: process.env.NEXT_PUBLIC_SUPABASE_URL ?? '',
    key: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '',
  },
};
